module.exports = __webpack_public_path__ + "img/img2.b3d0eeaa.png";